import ViewController from "core/views/view.controller";
import {Printer} from "ionic-native";

export default class BookingDetailsCtrl extends ViewController {
    static $inject = ['$q', '$scope', '$state', '$translate', '$ionicActionSheet', 'settings', 'Bookings'];

    constructor() {
        super(...arguments);

        this.showCustomer = true;
        this.showVehicle = true;
        this.showVehicleChecks = true;
        this.showWheelStorage = true;

        this.booking = null;
    }

    $onViewBeforeEnter() {
        this.booking = null;

        this.loadBooking(this.$state.params.bookingId);

        this.showCustomer = this.stateParam('showCustomer', true);
        this.showVehicle = this.stateParam('showVehicle', true);
        this.showVehicleChecks = this.stateParam('showVehicleChecks', true);
        this.showWheelStorage = this.stateParam('showWheelStorage', true);
    }

    loadBooking(bookingId) {
        return this.Bookings.get(bookingId).then((booking) => {
            return this.booking = booking;
        });
    }

    showActions($event) {
        this.$translate([
            'BOOKING_ACTIONS',
            'PRINT',
            'CANCEL'

        ]).then((translations) => {
            this.$ionicActionSheet.show({
                titleText: translations.BOOKING_ACTIONS,
                cancelText: translations.CANCEL,
                buttons: [
                    {text: translations.PRINT}
                ],

                buttonClicked: function (index) {
                    if (index == 0) {
                        self.printBooking($event);
                    }

                    return true;
                }
            });
        });
    }

    printBooking($event) {
        let bookingUrl = this.settings.httpUrl() + '/export/pdf/booking.seam?bookingId=' + this.booking.id;

        Printer.isAvailable().then(() => {
            Printer.print(bookingUrl, {bounds: [$event.pageX, 60, 0, 0]});
        })
    }

}



// WEBPACK FOOTER //
// ./src/modules/main/views/booking-details/booking-details.controller.js